export const CONSENT_MATCH_ID_CONSENT_CODE = 'consent-matchIDConsentCode-consentCategoryId';
export const CONSENT_SOURCE_TYPE = 'consentSourceType';
export const CONSENT_SAVED_CALLBACK_SOURCE = 'consentSavedCallbackSource';
export const CONSENT_CMP_PRESET = 'consentCmpPreset';
export const CONSENT_ONETRUST_COOKIE_NAME = 'consentOneTrustCookieName';
export const CONSENT_COOKIE_ENCODING = 'consentCookieEncoding';
export const CONSENT_COOKIE_WINDOW_VAR = 'consentCookieWindowVar';
export const CONSENT_JS_API_GLOBAL_OBJECT = 'consentJsApiGlobalObject';
export const CONSENT_JS_API_METHOD = 'consentJsApiMethod';
export const CONSENT_JS_API_PROPERTY_PATH = 'consentJsApiPropertyPath';
export const CONSENT_OPT_IN_VALUES = 'consentOptInValues';
export const CONSENT_GPC_ENABLED = 'consentGpcEnabled';
export const CONSENT_MATCH_ID_ENABLED = 'consentMatchIdEnabled';
export const CONSENT_GPC_CODES = 'consentGpcCodes';
